import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SEOProps {
    title: string;
    description: string;
    name?: string;
    type?: string;
    image?: string;
    url?: string;
}

export default function SEO({ title, description, name, type, image, url }: SEOProps) {
    const location = useLocation();
    const siteUrl = 'https://estebanlasso.com';
    const currentUrl = url || `${siteUrl}${location.pathname}`;

    return (
        <Helmet>
            { /* Standard metadata tags */}
            <title>{title}</title>
            <meta name='description' content={description} />

            { /* End standard metadata tags */}

            { /* Facebook tags */}
            <meta property="og:type" content={type || 'website'} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            { /* End Facebook tags */}

            { /* Twitter tags */}
            <meta name="twitter:creator" content={name || 'Esteban Lasso'} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            { /* End Twitter tags */}

            {image && <meta property="og:image" content={image} />}
            {image && <meta name="twitter:image" content={image} />}
            <meta property="og:url" content={currentUrl} />
        </Helmet>
    )
}
